import { LocalizedLanguage } from "../../framework/core/ll";
import { settings } from "../../framework/core/settings";

interface LoadBrandingOptions {
    setTitle?: boolean;
}
export interface BrandSettings {
    trimblepulse?: any;
    trimble?: any;
    servicepro?: any;
    singleBrandSetting?: boolean;
    brandName?: "trimble" | "trimblepulse" | "servicepro";
    learnMoreAboutCompanyName?: string;
    supportEmail?: string;
    address?: string;
    phoneNumber?: string;
    emailLogoUrl?: string;
    loadingLogoUrl?: string;
    appName?: string;
    brandFavIcon?: string;
    learnMoreAboutURLLabel?: string;
    marketingTag?: string;
    brandTabTitle?: string;
    learnMoreAboutURL?: string;
}
export function loadBranding(options: LoadBrandingOptions = {}) {
    const { setTitle = true } = options;

    const brandSettings = window.z.configuration.brandSettings;

    if (settings.brandName == "trimblepulse") {
        settings.appSettings = brandSettings.trimblepulse;

        LocalizedLanguage.BrandedLoginToAccessServicePro = "Login to access " + settings.appSettings.appName;
        LocalizedLanguage.BrandedRegistration = "Register for " + settings.appSettings.appName;
        LocalizedLanguage.BrandedAppName = settings.appSettings.appName;
        LocalizedLanguage.BrandedAboutInfo = "About " + settings.appSettings.appName;

        require("../../../Content/brand/trimblepulse/brand.less");
    } else if (settings.brandName == "trimble") {
        settings.appSettings = brandSettings.trimble;

        LocalizedLanguage.BrandedLoginToAccessServicePro = "Login to access " + settings.appSettings.appName;
        LocalizedLanguage.BrandedRegistration = "Register for " + settings.appSettings.appName;
        LocalizedLanguage.BrandedAppName = settings.appSettings.appName;

        require("../../../Content/brand/trimble/brand.less");
    } else if (brandSettings.singleBrandSetting === true) {
        settings.appSettings = brandSettings;

        LocalizedLanguage.BrandedLoginToAccessServicePro = "Login to access " + settings.appSettings.appName;
        LocalizedLanguage.BrandedRegistration = "Register for " + settings.appSettings.appName;
        LocalizedLanguage.BrandedAppName = settings.appSettings.appName;

        require(`../../../Content/brand/${brandSettings.brandName}/brand.less`);
    } else {
        settings.appSettings = brandSettings.servicepro;

        LocalizedLanguage.BrandedLoginToAccessServicePro = "Login to access Service Pro";
        LocalizedLanguage.BrandedRegistration = "Register for Service Pro";
        LocalizedLanguage.BrandedAppName = settings.appSettings.appName;
        LocalizedLanguage.BrandedAboutInfo = "About " + settings.appSettings.appName;

        require("../../../Content/brand/servicepro/brand.less");
    }

    changeFavIcon();
}

function changeFavIcon() {
    var link = document.createElement("link"),
        oldLink = document.getElementById("DynamicFavIcon");

    link.id = "DynamicFavIcon";
    link.rel = "shortcut icon";
    link.href = __webpack_public_path__ + (settings.appSettings && settings.appSettings.brandFavIcon) || "";

    if (oldLink) {
        document.head.removeChild(oldLink);
    }

    document.head.appendChild(link);
}
